import { useCallback, useState } from 'react';

/**
 *  creates and manages an isOpen state to be used as the prop of Modal component
 * @param {boolean} initialIsOpen - the initial value for isOpen state
 */
function useModal(initialIsOpen = false) {
  const [isOpen, setIsOpen] = useState(initialIsOpen || false);
  const [data, setData] = useState(null);

  const handleOpenModal = useCallback((data) => {
    setData(data);
    setIsOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setData(null);
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    handleCloseModal,
    handleOpenModal,
    data,
  };
}

export default useModal;
